'use client';

import { c as _c } from "react/compiler-runtime";
import { cva } from 'class-variance-authority';
import { AnimatePresence, motion } from 'framer-motion';
import Loader from '@/components/Loader';
const loadingVariants = cva('grid size-full place-items-center absolute inset-0 bg-black/30', {
  variants: {
    fixed: {
      true: 'fixed inset-0 pointer-events-auto z-[10000]'
    },
    absolute: {
      true: 'absolute inset-0 pointer-events-auto z-[10000]'
    }
  }
});
type LoadingProps = {
  fixed?: boolean;
  absolute?: boolean;
  className?: string;
  disableLoader?: boolean;
};
export default function Loading(t0) {
  const $ = _c(12);
  const {
    fixed: t1,
    absolute: t2,
    className,
    disableLoader: t3
  } = t0;
  const fixed = t1 === undefined ? true : t1;
  const absolute = t2 === undefined ? false : t2;
  const disableLoader = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== absolute || $[1] !== className || $[2] !== fixed) {
    t4 = loadingVariants({
      fixed,
      absolute,
      className
    });
    $[0] = absolute;
    $[1] = className;
    $[2] = fixed;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const loadingClasses = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 1,
      transition: {
        duration: 0.2,
        ease: "easeOut"
      }
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      hidden: t5,
      visible: t6,
      exit: {
        opacity: 0,
        transition: {
          duration: 0.15,
          ease: "easeIn"
        }
      }
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== disableLoader) {
    t8 = !disableLoader && <motion.div variants={{
      hidden: {
        opacity: 0
      },
      visible: {
        opacity: 1,
        transition: {
          duration: 0.3,
          ease: "easeOut",
          delay: 0.05
        }
      },
      exit: {
        opacity: 0,
        transition: {
          duration: 0.15,
          ease: "easeIn"
        }
      }
    }}><Loader /></motion.div>;
    $[7] = disableLoader;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== loadingClasses || $[10] !== t8) {
    t9 = <AnimatePresence mode="wait"><motion.div className={loadingClasses} variants={t7} initial="hidden" animate="visible" exit="exit">{t8}</motion.div></AnimatePresence>;
    $[9] = loadingClasses;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
}